/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { Col, Pagination, Row } from "react-bootstrap";
import { useTable, useSortBy, usePagination, useRowSelect } from "react-table";
import TypeTable from "./components/TypeTable";

interface IDataTable {
  className?: string,
  columns: any[],
  data: any[],
  setSelectedRows?: any,
  initialState?: any,
  paginate?: boolean,
  tableRowUpdate?: any,
  bordered?: boolean
}

const DataTable: React.FC<IDataTable> = ({
  className,
  columns,
  data,
  setSelectedRows,
  initialState = { pageIndex: 0, pageSize: 20 },
  paginate = true,
  tableRowUpdate = null,
  bordered = true,
}) => {

  const {
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    state: { pageIndex, selectedRowIds },
  } = useTable(
    {
      columns,
      data,
      initialState: initialState,
      tableRowUpdate,
    },
    useSortBy,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    if (setSelectedRows) {
      const selectedIds = Object.keys(selectedRowIds);
      var selectedRowsData = selectedIds
        .map((x:any) => data[x])
        .filter(function (x) {
          return x != null;
        });
      setSelectedRows(selectedRowsData);
    }
  }, [selectedRowIds]);

  return (
    <>
      {rows.length > 0 && (
        <TypeTable
          className={className}
          headerGroups={headerGroups}
          getTableBodyProps={getTableBodyProps}
          page={page}
          rows={rows}
          prepareRow={prepareRow}
          bordered={bordered}
        />
      )}

      {rows.length > 0 && paginate && (
        <>
          <Row className="d-flex flex-row align-items-center">
            <Col md="auto">
              <Pagination className="pt-2">
                <Pagination.First
                  onClick={() => gotoPage(1)}
                  disabled={!canPreviousPage}
                />
                <Pagination.Prev
                  onClick={() => previousPage()}
                  disabled={!canPreviousPage}
                />
                <Pagination.Next
                  onClick={() => nextPage()}
                  disabled={!canNextPage}
                />
                <Pagination.Last
                  onClick={() => gotoPage(pageCount - 1)}
                  disabled={!canNextPage}
                />
              </Pagination>
            </Col>
            <Col md="auto">
              <span>
                Página{" "}
                <strong>
                  {pageIndex + 1} de {pageOptions.length}
                </strong>{" "}
              </span>
            </Col>
          </Row>
        </>
      )}
    </>
  );
}

export default DataTable;
